var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{staticClass:"header-btn",staticStyle:{"background-color":"rgb(29, 111, 66)","color":"white"},attrs:{"loading":_vm.buttonExcelLoading,"icon":"file-excel"},on:{"click":function($event){return _vm.exportarExcel()}}},[_vm._v("\n  Excel\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04575aeb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/customization/GlobalBPOCore/components/ui/BtnExcel.vue
// module id = null
// module chunks = 